import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors } from '@zapier/design-system';
import { css } from '@emotion/react';
const DividerStyles = css({
    borderTop: `1px solid ${Colors.neutral300}`,
    marginTop: 4,
    marginBottom: 5,
});
export const Divider = () => isolateComponent("hr", { css: DividerStyles });
//# sourceMappingURL=Divider.js.map
// @zapier/universal-layout@8.11.3 (3d6dc537c)
